/* tslint:disable */

declare var Object: any;
export interface MachinePresentationInterface {
  "userAccountId": number;
  "shareId"?: string;
  "data"?: string;
  "tags"?: string;
  "createdAt": Date;
  "createdBy"?: number;
  "updatedAt": Date;
  "updatedBy"?: number;
  "id"?: number;
}

export class MachinePresentation implements MachinePresentationInterface {
  "userAccountId": number;
  "shareId": string;
  "data": string;
  "tags": string;
  "createdAt": Date;
  "createdBy": number;
  "updatedAt": Date;
  "updatedBy": number;
  "id": number;
  constructor(data?: MachinePresentationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MachinePresentation`.
   */
  public static getModelName() {
    return "MachinePresentation";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MachinePresentation for dynamic purposes.
  **/
  public static factory(data: MachinePresentationInterface): MachinePresentation{
    return new MachinePresentation(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MachinePresentation',
      plural: 'MachinePresentations',
      path: 'MachinePresentations',
      idName: 'id',
      properties: {
        "userAccountId": {
          name: 'userAccountId',
          type: 'number'
        },
        "shareId": {
          name: 'shareId',
          type: 'string'
        },
        "data": {
          name: 'data',
          type: 'string'
        },
        "tags": {
          name: 'tags',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'number'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedBy": {
          name: 'updatedBy',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
